"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EddMeasuresItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const EddMeasures_1 = require("../../enm/EddMeasures");
exports.EddMeasuresItem = {
    priority: 1,
    label: 'fields.enm.edd_measures.label',
    fallbackLabel: 'Please confirm the specific measures you apply in the EDD event.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_process_for_enhanced_due_diligence', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: EddMeasures_1.EddMeasuresRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_process_for_enhanced_due_diligence === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_process_for_enhanced_due_diligence === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
